<template>
    <fieldset
        class="radio"
        :form="formId"
    >
        <legend class="legend">
            <slot />
        </legend>

        <div
            v-for="option in options"
            :key="option.id"
            class="choice"
        >
            <RadioOptionInput
                :id
                v-model="model"
                :option
                :disabled
            />

            <label
                class="label"
                :for="`${id}-${option.id}`"
            >
                {{ option.label }}
            </label>
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import RadioOptionInput from './RadioOptionInput.vue'

export type RadioOption<TValue extends string | boolean = string> = {
    value: TValue
    label: string
    id: string
}

const { disabled = false, formId = undefined } = defineProps<{
    options:
        | RadioOption<string | boolean>[]
        | Readonly<RadioOption<string | boolean>[]>
    id: string
    formId?: string
    disabled?: boolean
}>()

const model = defineModel<string | boolean | null | undefined>({
    required: true,
})
</script>

<style lang="scss" scoped>
.radio {
    .choice {
        margin-bottom: 22px;

        .label {
            padding-left: 10px;
            font-family: $sectra-font-stack;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: var(--slate);
            cursor: default;
        }
    }

    &.diabled {
        .label {
            color: var(--grey-400);
        }
    }
}
</style>
